module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 10
// module chunks = 0